export default {
  '18838ed4a2bbcecf9f2fd03095c9ee99': 'I have read and agree to the',
  e69cd9cc1acea3c54a1a5636d5cfd594: '"User Service Agreement"',
  '46a8e8392001c13c67f883e9e2d62285': '"Automatic Renewal Agreement"',
  b72be4162301b6d49a3956896000d13a: '"User Purchase Agreement"'
};
